import React                        from 'react';
import { Button }                   from 'antd';
import { injectIntl }               from 'react-intl';
import { List }                     from 'antd';
import { observer }                 from 'mobx-react';
import { MailOutlined }             from '@ant-design/icons';
import { Space }                    from 'antd';
import { standDashboardStore }      from 'stores/index';
import Message                      from '../../Message/Message';
import { STATUS_CONVERTER }         from 'utils/constants';
import getAdditionalContent         from 'containers/Stand/helpers/getAdditionalContent';
import CardBox                      from 'components/App/CardBox';
import { AppForm }                  from 'components/App/AppForm';
import StandMessageConfirmationForm from 'forms/StandMessageConfirmationForm';
import StandMessageModel            from 'models/StandMessageModel';
import FormattedMessageWrapper      from 'components/App/FormattedMessageWrapper';
import StandMessageForm             from 'forms/StandMessageForm';
import rights                       from 'utils/rights';
import MessageModel                 from 'models/MessageModel';
import isMessageEditable            from 'utils/isMessageEditable';

export const MESSAGES_PER_PAGE = 50;

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

interface ContentProps {
  additionalContent: any;
  editMessage: (standMessage: StandMessageModel, message: MessageModel) => void;
}

const Content = observer(
  ({
    additionalContent,
    editMessage,
  }: ContentProps) => {
    const additionalContents: any = {};

    const {
      collMessage,
      collMessageMedia,
      collPagedStandMessage,
    } = standDashboardStore;

    if (
      collMessage.isLoaded &&
      !collMessage.isLoading &&
      collPagedStandMessage.isLoaded &&
      !collPagedStandMessage.isLoading &&
      collMessageMedia.isLoaded &&
      !collMessageMedia.isLoading
    ) {
      let contentDisplayed = false;

      standDashboardStore.collPagedStandMessage.forEach((standMessage: StandMessageModel, standMessageIndex) => {
        if (
          !contentDisplayed &&
          additionalContent.status !== STATUS_CONVERTER.waiting &&
          (standMessage.newStandStatus === additionalContent.status ||
            standMessageIndex === collPagedStandMessage.models.length - 1)
        ) {
          additionalContents[standMessage.id || ''] = additionalContent.additionalContent;
          contentDisplayed = true;
        } else {
          additionalContents[standMessage.id || ''] = null;
        }
      });
    }

    return (
      <List
        className="messages-list"
        dataSource={[ ...collPagedStandMessage.models ] as StandMessageModel[]}
        loading={collPagedStandMessage.isLoading || collMessage.isLoading}
        pagination={{
          current: collPagedStandMessage.page,
          defaultCurrent: collPagedStandMessage.page,
          hideOnSinglePage: true,
          onChange: page => {
            collPagedStandMessage.setPage(page);
            collPagedStandMessage
              .list()
              .then(() =>
                collMessage
                  .setFilter('id', collPagedStandMessage.getUniques('message.id'))
                  .list(),
              );
          },
          pageSize: collPagedStandMessage.itemsPerPage,
          size: 'small',
          total: collPagedStandMessage.total,
        }}
        renderItem={(item: StandMessageModel, itemIndex) => {
          const message = collMessage.findBy('id', item.messageId) as MessageModel;

          if (!item.id || !message) {
            return <List.Item key={item.id} />;
          }

          const editMessageEnabled =
            isMessageEditable(itemIndex, message.createdById, message.createdAtDate)
              ? () => editMessage(item, message)
              : null;

          return (
            <List.Item key={item.id}>
              <Message
                additionalContent={additionalContents[item.id]}
                editMessage={editMessageEnabled}
                lastMessage={itemIndex + 1 === collPagedStandMessage.length}
                message={message}
                messageMediaCollection={collMessageMedia}
                newStandStatus={item.newStandStatus}
              />
            </List.Item>
          );
        }}
        size="large"
      />
    );
  },
);

interface StandDashboardStandMessageListBoxProps {
  fetchParentData: () => void,
  intl: any;
}

class StandDashboardStandMessageListBox extends React.Component<StandDashboardStandMessageListBoxProps> {
  public render() {
    const {
      intl,
    } = this.props;

    const {
      stand,
    } = standDashboardStore;

    const additionalContent = getAdditionalContent(stand, this._openStandMessageFormModal, intl);

    return (
      <CardBox
          bodyStyle={{
            padding: 0,
          }}
          content={
            <Content
              additionalContent={additionalContent}
              editMessage={this._openStandMessageFormModal}
            />
          }
          extra={
            <Space orientation="horizontal">
              {additionalContent.status === STATUS_CONVERTER.waiting && (
                <div style={{ display: 'inline-block' }}>{additionalContent.additionalContent}</div>
              )}

              <Button
                disabled={!rights.for.standMessage.add}
                htmlType="button"
                onClick={() => {
                  this._openStandMessageFormModal(new StandMessageModel(), new MessageModel());
                }}
              >
                <FormattedMessageWrapper id="Envoyer un message" />
              </Button>
            </Space>
          }
          title={
            <>
              <MailOutlined style={styleIcon} /> <FormattedMessageWrapper id="Messages" />
            </>
          }
        />
    );
  }

  private _openStandMessageFormModal = (standMessage: StandMessageModel, message: MessageModel) => {
    const { fetchParentData, intl } = this.props;
    const { stand } = standDashboardStore;
    const additionalContent = getAdditionalContent(stand, this._openStandMessageFormModal, intl);

    if (additionalContent.withConfirmation) {
      AppForm.open(StandMessageConfirmationForm, {
        message,
        model: standMessage,
        onSuccess: fetchParentData,
        stand,
      },
      {
        okText: <FormattedMessageWrapper id="Confirmer" />,
        title: <FormattedMessageWrapper id="Confirmer" />,
        width: 1024,
      });
    } else {
      AppForm.open(StandMessageForm, {
        message,
        model: standMessage,
        onSuccess: fetchParentData,
        stand,
      },
      {
        okText: <FormattedMessageWrapper id="Envoyer" />,
        title: <FormattedMessageWrapper id="Envoyer un message / Répondre" />,
      });
    }
  };
}

export default injectIntl(StandDashboardStandMessageListBox);
